import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Circles({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M16.9999 3.767C13.9829 1.746 10.0169 1.746 6.99991 3.767M15.9799 19.32C19.2379 17.718 21.2209 14.283 20.9799 10.66M8.01991 19.32C4.76191 17.718 2.77891 14.283 3.01991 10.66M20.8546 5.68834C21.4404 6.27413 21.4404 7.22387 20.8546 7.80966C20.2688 8.39545 19.3191 8.39545 18.7333 7.80966C18.1475 7.22387 18.1475 6.27413 18.7333 5.68834C19.3191 5.10256 20.2688 5.10256 20.8546 5.68834ZM5.27257 5.68834C5.85836 6.27413 5.85836 7.22387 5.27257 7.80966C4.68679 8.39545 3.73704 8.39545 3.15125 7.80966C2.56547 7.22387 2.56547 6.27413 3.15125 5.68834C3.73704 5.10256 4.68678 5.10256 5.27257 5.68834ZM13.0636 19.1883C13.6494 19.7741 13.6494 20.7238 13.0636 21.3096C12.4778 21.8954 11.5281 21.8954 10.9423 21.3096C10.3565 20.7238 10.3565 19.7741 10.9423 19.1883C11.5281 18.6025 12.4778 18.6025 13.0636 19.1883ZM14.4749 8.774C15.8419 10.141 15.8419 12.357 14.4749 13.724C13.1079 15.091 10.8919 15.091 9.52491 13.724C8.15791 12.357 8.15791 10.141 9.52491 8.774C10.8919 7.407 13.1079 7.407 14.4749 8.774Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Circles;